<template>
  <div class="offers-item">
    <div class="desktop-offer-item">
      <!-- <div class="id"></div> -->
      <div class="amount">{{ item.loan_amount / 100 }}</div>
      <div class="term">{{ item.loan_term_days + "д." }}</div>
      <div class="percent">{{ item.annual_percent }}</div>
      <div class="income">
        {{ ((item.loan_amount + item.expected_income) / 100).toFixed(1) }}
      </div>
      <div class="rating">{{ item.borrower_min_rating }}</div>
      <div class="count">{{ item.loan_max_count }}</div>
      <div class="status">
        <div :class="`${item.status}-status`">
          {{ $t(`message.profile.lender.activeOffers.published.${item.status}`) }}
        </div>
      </div>
      <div class="menu" v-click-outside="hideOfferMenu">
        <template v-if="!readonly">
          <img
            @click.stop="offerMenuToggle()"
            class="offer-menu-img"
            src="../../../public/custom/images/offer-menu.svg"
            alt="Offer menu image"
            v-if="item.status !== 'blocked'"
          />
          <div class="offer-menu" v-if="isOfferMenuOpen">
            <div @click.stop="changeStatus()" class="offer-menu-item">
              {{
                $t(
                  `message.profile.lender.offer.${
                    item.status === "published" ? "unpublish" : "publish"
                  }`
                )
              }}
            </div>
            <div @click.stop="deleteOffer()" class="offer-menu-item offer-menu-item-delete">
              {{ $t('message.profile.lender.offer.delete') }}
            </div>
          </div>
        </template>
      </div>
    </div>
    
    <div class="mobile-offer-item">
      <div class="mobile-menu" v-click-outside="hideMobileOfferMenu">
        <template v-if="!readonly">
          <img
            @click.stop="mobileOfferMenuToggle()"
            class="offer-menu-img"
            src="../../../public/custom/images/offer-menu.svg"
            alt="Offer menu image"
            v-if="item.status !== 'blocked'"
          />
          <div class="offer-menu" v-if="isMobileOfferMenuOpen">
            <div @click.stop="changeStatus()" class="offer-menu-item">
              {{
                $t(
                  `message.profile.lender.offer.${
                    item.status === "published" ? "unpublish" : "publish"
                  }`
                )
              }}
            </div>
            <div @click.stop="deleteOffer()" class="offer-menu-item offer-menu-item-delete">
              {{ $t('message.profile.lender.offer.delete') }}
            </div>
          </div>
        </template>
      </div>
      <div class="preview-block">
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.amount') }}</div>
          <div class="data">{{ (item.loan_amount / 100).toFixed(2) }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.term') }}</div>
          <div class="data">{{ item.loan_term_days + " д." }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.percent') }}</div>
          <div class="data">{{ item.annual_percent }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.income') }}</div>
          <div class="data">{{ ((item.loan_amount + item.expected_income) / 100).toFixed(1) }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.rating') }}</div>
          <div class="data">{{ item.borrower_min_rating }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.count') }}</div>
          <div class="data">{{ item.loan_max_count }}</div>
        </div>
        <div class="mobile-row mobile-status">
          <div class="title">Публикация</div>
          <div :class="`${item.status}-status`">
            {{ $t(`message.profile.lender.activeOffers.published.${item.status}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: "landerOfferItem",
  props: {
    item: Object,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isOfferMenuOpen: false,
      isMobileOfferMenuOpen: false,
      isFullDesc: false
    };
  },
  methods: {
    descToggle() {
      this.isFullDesc = !this.isFullDesc;
    },
    offerMenuToggle() {
      this.isOfferMenuOpen = !this.isOfferMenuOpen;
    },
    mobileOfferMenuToggle() {
      this.isMobileOfferMenuOpen = !this.isMobileOfferMenuOpen;
    },
    hideOfferMenu() {
      this.isOfferMenuOpen = false;
    },
    hideMobileOfferMenu() {
      this.isMobileOfferMenuOpen = false;
    },
    changeStatus() {
      const status = this.item.status === 'published' ? 'not_published' : 'published';
      const public_id = this.item.public_id;

      this.$emit('changeOfferStatus', { status, public_id });
      this.hideOfferMenu();
      this.hideMobileOfferMenu();
    },
    deleteOffer() {
      this.$emit('deleteOffer', this.item.public_id);
      this.hideOfferMenu();
      this.hideMobileOfferMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
.offers-item {
  width: 100%;
}

.desktop-offer-item {
  width: 100%;
  padding: 20px 0 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: .895rem;
  line-height: 135%;
  color: #121212;
}

.mobile-offer-item {
  width: 100%;
  margin-bottom: 20px;
  min-height: 478px;
  padding: 24px 16px 56px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  position: relative;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
  background: #f8f8f8;
  border: 1px solid #cdcdcd;
  border-radius: 4.8px;
}

.id {
  width: 11%;
  margin-right: 2%;
  @include overflow-elipsis;
}

.amount {
  width: 10%;
  margin-right: 2%;
}

.term {
  width: 11%;
  margin-right: 2%;
}

.percent {
  width: 10%;
  margin-right: 2%;
}

.income {
  width: 9%;
  margin-right: 2%;
}

.rating {
  width: 7%;
  margin-right: 2%;
}

.count {
  width: 10%;
  margin-right: 2%;
}

.status {
  width: 10%;
  margin-right: 2%;

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.menu {
  width: 6%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.published-status {
  width: 48px;
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #214ea1;
  background: #d3e5f9;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
}

.successful_closed-status,
.processed-status {
  width: fit-content;
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #21A15C;
  background: #D6F9D3;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  white-space: nowrap;
}

.unpublished-status,
.not_published-status,
.blocked-status,
.failed-status,
.draft-status,
.archive-status,
.temporarily_blocked-status {
  width: 55px;
  padding: .3rem .7rem;
  box-sizing: border-box;
  background: #ffdbdb;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  color: #c93434;
}

.offer-menu-img {
  margin-right: 21px;
  height: 22px;
  width: 22px;
  cursor: pointer;
}

.offer-menu {
  padding: 0;
  box-sizing: border-box;
  position: absolute;
  top: -43px;
  right: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-size: 16px;
  line-height: 135%;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
}

.offer-menu-item {
  padding: 10px 15px;
  cursor: pointer;

  &:hover {
    background: #f7f7f7;
  }
}

.offer-menu-item-delete {
  border-top: 1px solid #cdcdcd;
  color: #c93434;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 71px;
  box-sizing: border-box;
}

.mobile-menu {
  height: 22px;
  position: absolute;
  top: 24px;
  right: 16px;
  display: flex;
  justify-content: flex-end;
}

.mobile-menu .offer-menu {
  top: 30px;
  right: 0;
}

.mobile-row {
  min-height: 22px;
  margin-bottom: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.mobile-row:last-child {
  margin-bottom: 0;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 115%;
  color: #878787;
}

.data {
  max-width: 58%;
  font-size: 16px;
  line-height: 115%;
  text-align: right;
  word-break: break-word;
}

.mobile-status div:last-of-type {
  width: auto;
  padding: 5px 11px;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 12px;
  line-height: 115%;
}

@media screen and (max-width: 850px) {
  .desktop-offer-item {
    display: none;
  }

  .mobile-offer-item {
    display: flex;
  }
}
</style>
